import { Reveal, SectionHeading } from "./Reveal";
import { STEPS } from "../../data/site";

export const HowItWorks = () => (
  <section id="como-funciona" className="bg-white py-20 lg:py-28" data-testid="how-it-works-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeading
        number="04"
        eyebrow="Como funciona"
        title="Simples, rápido e sem complicações"
        subtitle="Do primeiro contacto ao resultado final, tudo pensado para ser fácil para si."
      />

      <div className="relative mt-16">
        <div
          className="absolute left-[12%] right-[12%] top-10 hidden h-px bg-gradient-to-r from-brand/10 via-brand/40 to-brand/10 lg:block"
          aria-hidden="true"
        />
        <ol className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6">
          {STEPS.map((step, i) => (
            <Reveal key={step.n} delay={i * 0.12}>
              <li data-testid={`step-${step.n}`} className="group relative text-center lg:text-left">
                <div className="relative z-10 mx-auto grid h-20 w-20 place-items-center rounded-3xl border border-brand/15 bg-white shadow-[0_8px_30px_rgba(0,102,255,0.1)] transition-all duration-500 group-hover:-translate-y-1 group-hover:shadow-[0_16px_40px_rgba(0,102,255,0.18)] lg:mx-0">
                  <span className="bg-gradient-to-br from-brand to-aqua bg-clip-text font-mono text-2xl font-semibold text-transparent">
                    {step.n}
                  </span>
                </div>
                <h3 className="mt-6 text-lg font-bold tracking-tight text-navy">{step.title}</h3>
                <p className="mx-auto mt-2 max-w-[240px] text-sm leading-relaxed text-slate-500 lg:mx-0">
                  {step.desc}
                </p>
              </li>
            </Reveal>
          ))}
        </ol>
      </div>
    </div>
  </section>
);
